export class SMS {
    static readonly ContentMaximumLength = 320;
    static readonly ContentMinimumLength = 6;

    static readonly SearchCalendar = 'anelma-short-message-list-view-search-calendar';
    static readonly SearchCalendarFromDate = 'anelma-short-message-from-date';
    static readonly SearchCalendarToDate = 'anelma-short-message-to-date';
}
